import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import languageService from '../../services/language';
import './index.css';

export default class Footer extends Component {
  renderContent() {
    const pagesWithMenuItems = this.props.global.pages.filter(page => page.headerMenuPriority);

    const menuItems = pagesWithMenuItems
    .concat({
      path: '/infopublic',
      headerMenuPriority: 4,
      headerMenuItem: {
        'Ro': 'Informații de interes public',
        'En': 'Public interest'
      }
    })
    .sort((a, b) => a.headerMenuPriority > b.headerMenuPriority)
    .map((page, index) => {
      const props = {
        className: 'comp-footer__menuitem',
        key: `footer-${page.headerMenuItem}-${index}`,
        to: page.path
      };

      return (
        <Link {...props}>
          <span>{page.headerMenuItem[languageService.language]}</span>
        </Link>
      );
    });

    return (
      <div className="row">
        <div className="col-md-2 u-flex-center">
          <img className="logo" src={this.props.global.logoUrl} alt="Aeroport Iasi" />
        </div>
        <div className="col-md-8 comp-footer__menuitems u-flex-center">
          {menuItems}
        </div>
        <div className="col-md-2 u-flex-center social-icons">
          <a href="https://www.facebook.com/IASIairport/" target="_blank">
            <i className="fa fa-facebook-official" />
          </a>
          <a href="https://twitter.com/iasiairport" target="_blank">
            <i className="fa fa-twitter" />
          </a>
        </div>
      </div>
    );
  }

  render() {
    let rendered = null;

    if (this.props.global) {
      rendered = this.renderContent();
    }

    return (
      <div className="comp-footer m-t-big">
        {rendered}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/footer/index.js